$(window).on('load', function(){
 
  setTimeout(function(){
    $('.course-video-wrapper .video-frame .lty-playbtn').trigger("click");
    $('.quantity_button_from_api').css('display','initial');
  }, 500);
});

// $('.ContactFormMessage, .contact-checkbox, .loginalert').bind('click keyup keypress ' , function(){
//     alert("로그인이 필요합니다.");
//   window.location.href='https://www.tens10.com/account/register';
// })

$(document).ready(function(){
  $('.js-drawer-open-nav').click(function(){
    $('#Linklist-2').addClass('is-open');
  });
  $('.menu-close').click(function(){
    $('#Linklist-2').removeClass('is-open');
  });
  $('#course-image-text-section_index').css('display','block');
  $('#course-image-text-section_proficiency').css('display','block');
  
  if(purchase_qty > 0){
  var qtyId = $('.sticky_atc_share-outer .a').attr('product-id');
  $.ajax({
    type : "GET",
    url : "http://tens10.me/ten10/order_webhook_data.php?product_id="+qtyId,
    dataType : "json",
    async : false,
    success : function(result){
      var reminderQty = (result % purchase_qty);
      $('.quantity_button_from_api').css('display','initial');
      if( reminderQty == 0){
        var qty = purchase_qty;
      }else{
        var qty = purchase_qty - reminderQty;
      }
      $('.quantity_button_from_api').text(qty);
    },
    error : function(){
      $('.quantity_button_from_api').css('display','initial');
    }
  });
  }else{
    $('.quantity_button_from_api').text('0');
    $('.quantity_button_from_api').parent().parent().addClass('quantity_button_from_api_disable');
  }
  
 $('body').on('click','.help_center-top_right-inner .help_btn', function(){
	$('#ch-plugin-core .Launcherstyled__Wrapper-oef45p-0').trigger("click");
  });
  
  $('body').on('click','.master_package-btn', function(){
    $(this).toggleClass('active');
    $(this).parent().find('.master_package-outer').slideToggle();
  });
  
  document.addEventListener("contextmenu", function (e){
    e.preventDefault();
  }, false);
  
  var dest = new Date("March 05,2022 00:00:00").getTime();
  var x = setInterval(function(){
    var now = new Date().getTime();
    var diff = now - dest ;
    var  day = Math.floor(diff / (1000* 60*60*purchase_day));
    $('.limited_qty-subcontent span.timer').text(day+'차'); 
  },1000);
  

  $('.announcement-bar .announcement-promo-banner-close').click(function(){
    $('.announcement-bar').slideUp(300);
    $('body').addClass('announcement');
  });
  
  $('.tabcontent-wrapper .tabtext').click(function(){
    var tab_active = $(this).data('tab');
    $('.tabcontent-wrapper .tabtext').removeClass('tab-active');
    $(this).addClass('tab-active');
    $('.tabcontent-description .main-image-tab-info').removeClass('tab-info-active');
    $('.tabcontent-description .main-image-tab-info[data-tab-info="'+tab_active+'"]').addClass('tab-info-active');
  });

  var $temp = $("<input>");
  var $url = $(location).attr('href');
  $('.social_buttons .clipboard').on('click', function() {
    $temp.val('https://tens10.com/').select();
    document.execCommand("copy");
    $temp.remove();
    alert("링크가 복사되었습니다.");
  });
  
  $('.sticky_atc_share_btn, #price_hp_share-btn').on('click', function() {
    $(this).parent().find('input').select();
    document.execCommand("copy");
    alert("링크가 복사되었습니다.");
  });
  
  $('.new-multiimg-section .customer-login-image').click(function(){
    if (confirm("로그인이 필요합니다."))
    {
      window.location = '/account/login';
    }
  });
  $('.sticky_product-btn.customer').click(function(){
    alert("로그인이 필요합니다.");
    window.location = '/account/login';
  });
 $('.site-nav__link.login-alert').click(function(){
    alert("로그인이 필요합니다.");
  });
  $('.product-checkout .login-alert').click(function(){
    alert("로그인이 필요합니다.");
    window.location = '/account/login';
  });
  $('.sticky-btn.login-alert a').click(function(){
     alert("로그인이 필요합니다.");
  });
  $('.product-btn-home.login-alert a').click(function(){
  	alert("로그인이 필요합니다.");
  });
  $('.classis-btn-content.login-alert a').click(function(){
   alert("로그인이 필요합니다.");
  });
  $('.master-block-button.login-alert').click(function(){
  	alert("로그인이 필요합니다.");  
  });
  
  $('#course-image-text-main_proficiency').slick({
    dots: false,
    arrows:false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.course-imgtxt-wrapper_proficiency'
  });

   $('.course-imgtxt-wrapper_proficiency').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow:1,
    slidesToScroll: 1,
    focusOnSelect: true,
    draggable:true,
    asNavFor: '#course-image-text-main_proficiency',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  $('.review_section_block-outer').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow:2,
    slidesToScroll: 1,
    draggable:true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  $('.course-video-wrapper .inner-video-wrapper').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow:1,
    centerMode: true,
    vertical: false,
    draggable:true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        }
      }
    ]
  });

  $('.new-multislider-section .multislider-wrapper').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow:2,
    centerMode: true,
    vertical: false,
    draggable:true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        }
      }
    ]
  });

  $('.gallery-wrapper .gallery-inner-wrap').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow:4,
    centerMode: true,
    variableWidth: true,
    vertical: false,
    draggable:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        }
      }
    ]
  });
  
    $('.new-image-with-text-banner .new-banner-main').slick({
      dots: true,
      arrows:false,
      infinite: false,
      slidesToShow:3,
      autoplay: true,
      autoplaySpeed: 800,
      infinite: true,
      draggable:true,
      responsive: [
        {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  if( $(window).width() >= 769) {
    $('#course-image-text-section_index').slick({
      dots: false,
      arrows:true,
      infinite: true,
      slidesToShow:4,
      draggable:true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5845 8.74951L0 9.33496L0.5845 8.74951L0 8.16406L0.5845 8.74951L8.59921 0.724609L0.5845 8.74951L8.59921 16.7744L0.5845 8.74951Z" stroke="white" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5845 8.74951L0 9.33496L0.5845 8.74951L0 8.16406L0.5845 8.74951L8.59921 0.724609L0.5845 8.74951L8.59921 16.7744L0.5845 8.74951Z" stroke="white" stroke-width="3"/></svg></button>',
    });
  }else{
    $('#course-image-text-section_index').slick({
      dots: false,
      arrows:false,
      infinite: true,
      slidesToShow:3,
      draggable:true,
      //autoplay : true,
      //autoplaySpeed: 800,
    });
  }

  $('.course-video-wrapper .video-inner .video-frame').click(function(){
    $(this).addClass('video-play');
  });

  $('.menu-open .js-drawer-open-nav').click(function(){
    $('.menu-open').addClass('menu-nav-open');
  });
  $('.menu-open .drawer__close .menu-close').click(function(){
    $('.drawer__close .js-drawer-close').trigger('click');
    $('.menu-open').removeClass('menu-nav-open');
  });


  $("#select-all").click(function() {
    var checkBoxes = $("input");
    checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  }); 

  $(".checkbox-wrapper input").click(function() {
    $('#select-all').removeprop('checked');
  }); 


  $('.header-item .site-nav__item .site-nav__link').click(function(){
    $('.header-item .site-nav__item').not($(this).parent()).removeClass('active');
    $(this).parent().toggleClass('active');
  });

$('.header-item  .site-navigation .site-nav__link').click(function(){
    var that = $(this).attr('href');
    var string = that.split('#');
    var href = string[1];
    var target = $('#'+href);
   $('html, body').animate({
        'scrollTop' :  $(target).position().top
    });
  });
  
});


$(window).on('load', function() {       
  $(".ttloader").fadeOut(500); 
  $(".ttloader .rotating").addClass("load-open");  
});

function checkNameEmpty(inputID)
{
  $(inputID).keyup(function(){

    if($(this).val() == '')
    {
      $(this).parent().find(".error").show();
      $(this).addClass("error-border");
    } 
    else 
    {
      $(this).parent().find(".error").hide();
      $(this).removeClass("error-border");
    }
  });
}

//regex to validate email
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

// validation for email input using validateEmail Function
function checkValidEmail(emailInputID){
  $(emailInputID).keyup(function(){
    var email = $(emailInputID).val();
    if (validateEmail(email)) 
    {
      $(this).parent().find(".error").hide();
      $(this).removeClass("error-border");
    }
    else 
    {
      $(this).parent().find(".error").show();
      $(this).addClass("error-border");
    }
  });
}
// regex to validate phone
function validatePhone(inputtxt) {

  var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
  if(inputtxt.match(phoneno)) 
  {
    return true;
  }  
  else 
  {  
    return false;
  }
}
// validation for phone input using validatePhone Function
function checkvalidPhoneNumber(phoneInputID){
  $(phoneInputID).keyup(function(){
    var phone = $(phoneInputID).val();
    var getPhone = validatePhone(phone);
    if(getPhone)
    {
      $(this).parent().find(".error").show();
      $(this).addClass("error-border");

    } 
    else 
    {
      $(this).parent().find(".error").hide();
      $(this).removeClass("error-border");
    }
  });
}
function checkComment(passwprd){
  $(passwprd).keyup(function(){

    if($(this).val() == '')
    {
      $(this).parent().find(".error").show();
      $(this).addClass("error-border");
    } 
    else 
    {
      $(this).parent().find(".error").hide();
      $(this).removeClass("error-border");
    }
  });
}
function checklogComment(passwprd){
  $(passwprd).keyup(function(){

    if($(this).val() == '')
    {
      $(this).parent().find(".error").show();
      $(this).addClass("error-border");
    } 
    else 
    {
      $(this).parent().find(".error").hide();
      $(this).removeClass("error-border");
    }
  });
}

$(document).ready(function(){

  //when click on submit
  $("#create_customer .sign-submit .btn").click(function(e){
    checkNameEmpty("#FirstName");
    checkValidEmail("#Email");
    //  checkvalidPhoneNumber("#customerphone");
    checkComment("#CreatePassword");


    if($(".input input").val() == '')
    {
      $(".error").show();
      $(".input input").addClass("error-border");

    }

    if($("#FirstName").val() == '')
    {
      $('#FirstName').parent().find(".error").show();
      $('#FirstName').addClass("error-border");

    }
    if($("#Email").val() == '')
    {
      $('#Email').parent().find(".error").show();
      $('#Email').addClass("error-border").show();

    }
    if($("#Email").val() != '')
    {
      var email = $("#Email").val();
      if (!validateEmail(email)) 
      {
        $('#Email').parent().find(".error").show();
        $('#Email').addClass("error-border");

      } 
    }
    if($("#customerphone").val() == '')
    {
      $('#customerphone').parent().find(".error").show();
      $('#customerphone').addClass("error-border");

    }

    if($("#customerphone").val() != '')
    {
      var getPhone = validatePhone($("#customerphone").val());
      if(!getPhone && getPhone.length != 11)
      {
        $('#customerphone').parent().find(".error").hide();
        $('#customerphone').removeClass("error-border");

      }
    }
    if($("#CreatePassword").val() == '')
    {
      $('#CreatePassword').parent().find(".error").show();
      $('#CreatePassword').addClass("error-border");

    }
  });


  //when click on submit
  $("#customer_login .button-wrap .btn").click(function(e){
    //run time form validation
    checkValidEmail("#CustomerEmail");
    checkComment("#CustomerPassword");

    if($(".input input").val() == '')
    {
      $(".error").show();
      $(".input input").addClass("error-border");

    }

    if($("#CustomerEmail").val() == '')
    {
      $('#CustomerEmail').parent().find(".error").show();
      $('#CustomerEmail').addClass("error-border");

    }
    if($("#CustomerEmail").val() != '')
    {
      var email = $("#CustomerEmail").val();
      if (!validateEmail(email)) 
      {
        $('#CustomerEmail').parent().find(".error").show();
        $('#CustomerEmail').addClass("error-border");

      } 
    }
    if($("#CustomerPassword").val() == '')
    {
      $('#CustomerPassword').parent().find(".error").show();
      $('#CustomerPassword').addClass("error-border");

    }
  });

  $("#RecoverEmail").keyup(function(){
    var val = $(this).val();
    var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;


    if (testEmail.test(val)){
      $('#RecoverEmail').parent().find(".error").hide();
      $('#RecoverEmail').removeClass("error-border");
    } 
    else{
      $('#RecoverEmail').parent().find(".error").show();
      $('#RecoverEmail').addClass("error-border");

    }

  });
//   $('#customerphone').keyup(function(){

//     if($("#customerphone").val() != '')
//     {
//       var getPhone = validatePhone($("#customerphone").val());

//       if($("#customerphone").val().length == 11){
//         $('#customerphone').parent().find(".error").hide();
//         $('#customerphone').removeClass("error-border");
//       }else{
//         $('#customerphone').parent().find(".error").show();
//         $('#customerphone').addClass("error-border");
//       }
//     }

//   });

  $('#RecoverPasswordForm .btn').click(function(){
    if($('#RecoverEmail').val() == ''){
      $('#RecoverEmail').parent().find(".error").show();
      $('#RecoverEmail').addClass("error-border");
    }
  });

  //   $("#customerphone").on("input", function(e) {
  //     var self = $(this);
  //     self.val(self.val().replace(/^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/, ""));
  //     if ((e.which < 48 || e.which > 57)) 
  //     {
  //       e.preventDefault();
  //     }
  //   });

});

$('#customerphone').blur(function(){
  var phone = $(this).val();
var country_code = $(' .registration_phone .iti__selected-dial-code').text();
    localStorage.setItem('phone', country_code+phone);
});

// Header stickey 
// jQuery(function($) {
//   $(window).scroll(function fix_element() {
//     $('.header-sticky-wrapper').css(
//       $(window).scrollTop() > 100
//       ? { 'position': 'fixed', 'top': '0', 'z-index':'7', 'width':'100%'}
//       : { 'position': 'relative', 'top': 'auto','border-bottom': 'none' }

//     );
//     return fix_element;
//   }());
// });

// alert popup
$('.bottom_price_hp-outer .login-alert,.price_hp_share-outer .mobile-pricing-login').click(function(){
  if (confirm("로그인이 필요합니다."))
  {
    window.location = '/account/login';
  }
});

$('.customer-marketin-popup').click(function(e){
  e.preventDefault();
  $('body').addClass("marketing-popup-open");
$('#marketing-popup-main').show();
});


/*------   body click close open any drawer -----*/
$(document).mouseup(function(e) 
{
    var container = $(".marketing_popup .marketing_popup-main");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0 ) 
    {
     $('body').removeClass("marketing-popup-open");
$('#marketing-popup-main').hide();
    }
});


$('#marketing-popup-main .popup-button').click(function(e){
  e.preventDefault();
  var id = $(this).find('span').attr('data-cus-id');
  //   https://shopify.html-projects.ml/
  if($('input[name="customer[accepts_marketing]"]').prop('checked') == true){
    $('.checkbox_error').hide();
    $.ajax({
      url: "https://shopify.html-projects.ml/tens_jay/tens_cus_update.php",
      type: "POST",
      data: {id : id},
      success: function(data){
        console.log("update");
        $('body').removeClass("marketing-popup-open");
        window.open('https://cdn.shopify.com/s/files/1/0512/8857/2058/files/X_1.pdf?v=1647938323');
        $('#marketing-popup-main').hide();
        $('.popup_checkbox label').removeClass('error-label');
      }
    });
  }else{
    $('.popup_checkbox label').addClass('error-label');
    $('.checkbox_error').show();
  }
});
$('input[name="customer[accepts_marketing]"]').change(function(){
  if($(this).prop('checked') == true){
    $('.checkbox_error').hide();
    $('.popup_checkbox label').removeClass('error-label');
  }else{
    $('.checkbox_error').show();
    $('.popup_checkbox label').addClass('error-label');
  }
});

// new upsell popup
$('.producthome-upsellbtn').click(function(){
  $('body').addClass('upsell-open');
  $('.basic-popup-area').css('display','block');
  $('.basic-popup-area').addClass('basic-popup-open');
});

$('.basic-popup-area .basic-popup-close').click(function(){
  $('body').removeClass('upsell-open');
  $('.basic-popup-area').css('display','none');
   $('.basic-popup-area').removeClass('basic-popup-open');
});

// home page note section
$('.home-contact-info .contact-form-wrapper .form-submit .loginalert').click(function(){
  var $this = $(this),
  textareaval = $(this).parents('.contact-form-inner').find('form textarea[id="ContactFormMessage"]').val(),
    loginbefore_error = $(this).data('loginerror'),
    login_after = $(this).data('loginafter'),
    login_textarea_valerror = $(this).data('textarealength'),
    login_checkbox_error = $(this).data('checkboxerror');
  alert(loginbefore_error);
    window.location.href='https://www.tens10.com/account/login';
});
$('.home-contact-info .contact-form-wrapper .form-submit .submit-input').click(function(){
  var $this = $(this),
  textareaval = $(this).parents('.contact-form-inner').find('form textarea[id="ContactFormMessage"]').val(),
    loginbefore_error = $(this).data('loginerror'),
    login_after = $(this).data('loginafter'),
    login_textarea_valerror = $(this).data('textarealength');
  var login_checkbox_error = $(this).data('checkboxerror');
  if($(this).parents('.contact-form-inner').find('form input[type="checkbox"]').prop('checked') == false){
    alert(login_checkbox_error);
  }else{
    var textareaValue = $('.home-contact-info form textarea.customer-input').val();
    if(textareaValue.length < 10){
      alert(login_textarea_valerror);
    }else{
    
      var id = $this.attr('data-customer-id');

   var d = new Date();

var month = d.getMonth()+1;
var day = d.getDate();

var output = d.getFullYear() + 
    ((''+month).length<2 ? '0' : '') + month  +
    ((''+day).length<2 ? '0' : '') + day;

      var note = output+"_"+$('#ContactFormMessage').val();
      var tag;
      alert(login_after);
      $.ajax({
        type: "GET",
        url: "http://ah-portfolio.cloudaccess.host/shopify-api/get_all_tag.php",
        data: {
          customer_id:id
        },
        success: function(data){
          
          var json1 = JSON.parse(data);
          note = json1.customer.note +'\ncustom note:- '+note+' \n';
          tag = json1.customer.tags +','+ output+"(date)_ddd";
          console.log(tag);
          $.ajax({
            type: "GET",
            url: "http://ah-portfolio.cloudaccess.host/shopify-api/update-user.php",
            data: {
              customer_id:id,
              note:note,
              tags:tag
            },
            success: function(data){
              console.log(data);                
             }
          });
         }
      });
       

    }
  }
});

$('.site-header .grid__item.medium-up--one-fifth.appear-animation.appear-delay-1 a, .site-header .grid__item.medium-up--one-fifth.appear-animation.appear-delay-2 a').click(function(e) {
  let title = $(this).text().trim();
  
  analytics.track('product_clicked', {
    product_name: title
  });
});

$('#product-home .btn.product-btnlink').click(function (e) {
  let title = $(this).closest('.product-home-main').find('.product-home-img-txt').text().trim();

   analytics.track('product_clicked', {
    product_name: title
  });
});

$('#sidebar_content-product a.a').click(function (e) {
  let title = $(this).closest('#sidebar_content-product').find('.sticky_product-title').text().trim();
  
   analytics.track('product_clicked', {
    product_name: title
  });
});

$('.all_in_one_product-btn').closest('a').click(function (e) {
  let title =  $(this).text();

  analytics.track('product_clicked', {
    product_name: title
  });
});

$('.basic-popup-button-inner a').click(function(e){
  const map = {
    'basic-popup-first': '업셀링 마스터 클래스',
    'basic-popup-sec': '업셀링 코미꼬 클래스'
  };
  let title = $(this).attr('class');
  
  analytics.track('product_clicked', {
    product_name: map[title]
  });
});
